import { template } from 'lodash';
import axios from './client';

const MATERIALS_CATEGORY = '/materials-category';
const MATERIALS_BY_CATEGORY_ID = template('/materials/<%= catId %>');
const ASK_QUESTION = '/materials/ask-question';
const SET_STAT_VIDEO = '/materials/set-stat-video';

const CATEGORIES = template('/materials/categories?type=<%= type %>&page=<%= page %>&limit=<%= limit %>');
const CATEGORY_ADD = '/materials/category';
const CATEGORY_EDIT = template('/materials/category/<%= id %>');
const CATEGORY_DELETE = template('/materials/category/<%= id %>');

const MATERIALS = '/materials';
const MATERIAL_ADD = '/materials';
const MATERIAL_EDIT = template('/materials/<%= id %>');
const MATERIAL_DELETE = template('/materials/<%= id %>');

/**
 * Get all materials category
 * @returns {Promise}
 */
export function materialsCategory(userId) {
  let param = '';
  param = `?userId=${userId}`;
  return axios.get(MATERIALS_CATEGORY + param, { timeout: 0 });
}
export function categories(type, page, limit) {
  return axios.get(CATEGORIES({ type, page, limit }), { timeout: 0 });
}
export function addCategory(data) {
  return axios.post(CATEGORY_ADD, data);
}
export function editCategory(data, id) {
  return axios.post(CATEGORY_EDIT({ id }), data);
}
export function deleteCategory(id) {
  return axios.delete(CATEGORY_DELETE({ id }));
}


export function materials(params) {
  return axios.get(MATERIALS, { params, timeout: 0 });
}
export function addMaterial(data) {
  return axios.post(MATERIAL_ADD, data);
}
export function editMaterial(data, id) {
  return axios.post(MATERIAL_EDIT({ id }), data);
}
export function deleteMaterial(id) {
  return axios.delete(MATERIAL_DELETE({ id }));
}

/**
 * Get all materials by categoryId
 * @param catId
 * @param userId
 * @param page
 * @param limit
 * @returns {Promise}
 */
export function materialsByCategoryId(userId, catId, page, limit) {
  let param = '';
  param = `?userId=${userId}&page=${page}&limit=${limit}`;
  return axios.get(MATERIALS_BY_CATEGORY_ID({ catId }) + param, { timeout: 0 });
}

export function sendQuestion(params) {
  const headers = { 'Content-Type': 'multipart/form-data' };
  return axios.post(ASK_QUESTION, params, { headers });
}

export function setStatVideo(params) {
  const headers = { 'Content-Type': 'multipart/form-data' };
  return axios.post(SET_STAT_VIDEO, params, { headers });
}
